/*
  OBSI – <obsi-countdown> custom element.
  Counts down to data-deadline (ISO local datetime). Renders into child
  elements [data-days]/[data-hours]/[data-minutes]/[data-seconds].
  On completion: data-complete="message" reveals [data-countdown-complete]
  and hides [data-countdown-timer]; otherwise it hides the whole element.
*/
if (!customElements.get('obsi-countdown')) {
  customElements.define(
    'obsi-countdown',
    class ObsiCountdown extends HTMLElement {
      connectedCallback() {
        this.deadline = new Date(this.dataset.deadline).getTime();
        this.completeMode = this.dataset.complete || 'hide';
        this.timerEl = this.querySelector('[data-countdown-timer]');
        this.doneEl = this.querySelector('[data-countdown-complete]');
        this.parts = {
          days: this.querySelector('[data-days]'),
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]'),
        };

        if (isNaN(this.deadline)) return;

        this.tick = this.tick.bind(this);
        this.tick();
        this.interval = setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        var diff = this.deadline - Date.now();
        if (diff <= 0) {
          clearInterval(this.interval);
          this.complete();
          diff = 0;
        }
        var total = Math.floor(diff / 1000);
        this.render(this.parts.days, Math.floor(total / 86400));
        this.render(this.parts.hours, Math.floor((total % 86400) / 3600));
        this.render(this.parts.minutes, Math.floor((total % 3600) / 60));
        this.render(this.parts.seconds, total % 60);
      }

      render(el, value) {
        if (el) el.textContent = String(value).padStart(2, '0');
      }

      complete() {
        if (this.completeMode === 'message' && this.doneEl) {
          if (this.timerEl) this.timerEl.hidden = true;
          this.doneEl.hidden = false;
        } else {
          this.hidden = true;
        }
      }
    }
  );
}
